export default function test(str) {
    if (!str) return true;
    if (str === "") return false;
    // regexp based check, allow only digits
    return /\/([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(str);
}